import React, { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
// import datacloud from "../../Assets/data-cloud.jpeg";
// import dynamic from "../Asse/ts/dynamic_image.jpeg";
import datacloud from "../../Assets/data-cloud.png";
import time from "../../Assets/newlogo.jpg";
import { useDispatch, useSelector } from "react-redux";
import {
  requestBackgroundImage,
  requestLoginAction,
  setResetStateLogin,
} from "../../Redux/LoginState/LoginActionCreator";
import { useNavigate } from "react-router-dom";
import ForgotPasswordForm from "./ForgotPasswordForm";
import Loader from "../../components/Loader";
import LOCAL_KEYS, { setToLocalStorage } from "../../helpers/Localstorage";
// import ResetForm from "./ResetForm";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dynamicImage, setDynamicImage] = useState("");
  const [dynamicImages, setDynamicImages] = useState([time]);
  const BackgroundImageReducer = useSelector((state) => state.FileReducer);

  const { loginResponse } = useSelector((state) => state.LoginReducer);
  const ForgetPasswordState = useSelector(
    (state) => state.ForgotPasswordReducer
  );

  useEffect(() => {
    if (loginResponse !== null) {
      setToLocalStorage(LOCAL_KEYS.ACCESS_TOKEN, loginResponse.access_token);
      setToLocalStorage(LOCAL_KEYS.REFRESH_TOKEN, loginResponse.refresh_token);
      setToLocalStorage(LOCAL_KEYS.USER_DETAILS, loginResponse.userDetails);
      dispatch(setResetStateLogin());
      navigate("/", { replace: true });
    }
  }, [loginResponse]);

  // useEffect(() => {
  //   dispatch(requestBackgroundImage());
  // }, []);

  // useEffect(() => {
  //   if (
  //     BackgroundImageReducer?.response &&
  //     BackgroundImageReducer?.response?.blobUrl &&
  //     !BackgroundImageReducer?.loading
  //   ) {
  //     setDynamicImages([BackgroundImageReducer?.response?.blobUrl, time]);
  //   }
  // }, [BackgroundImageReducer]);

  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    waitForAnimate: false,
  };

  return (
    <div className="flex min-h-screen ">
      <Loader isLoading={ForgetPasswordState?.loading} />
      <div className="hidden sm:flex w-10/12 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0  to-slate-900 opacity-75"></div>
          {/* <Slider {...settings}> */}
          {dynamicImages.map((img, index) => (
            <img
              key={index}
              className="h-full w-full object-cover"
              src={img}
              alt={`Background ${index}`}
            />
          ))}
        </div>
        {/* </Slider> */}
        <div className="relative z-10 flex items-center h-full px-8 lg:px-16">
          <div className="max-w-xl">



          </div>
        </div>
      </div>
      <div className="w-full sm:w-1/3 flex items-center justify-center p-6">
        <ForgotPasswordForm />
      </div>
    </div>

    // </div>
  );
};

export default ForgotPassword;
